export default __webpack_public_path__ + "static/media/SCANIA_stand_pnsv2021.d3362e60.jpg";